import * as React from 'react'

import { Card } from '@grandvisionhq/common'
import { useIntl } from '@grandvisionhq/state'

import { SummaryProps } from '../types'
import { formatDateOfBirth, isValidDate } from '~/util/date-utils'

interface Props extends SummaryProps {
  actions?: {
    onEdit?: () => void
  }
}

const ContactDetailsSummary = ({ actions, values = {} }: Props) => {
  const { locale, getLabel } = useIntl()
  const date = values.dateOfBirth || values.customerDateOfBirth || values.customerDOB || ''

  return (
    <Card>
      <Card.Content>
        {actions?.onEdit && (
          <Card.Actions>
            <Card.Button onClick={actions.onEdit} children={getLabel('common.actions.edit')} />
          </Card.Actions>
        )}
        {isValidDate(date) && <Card.Text>{formatDateOfBirth(date, locale)}</Card.Text>}
        {values.phone && <Card.Text>{values.phone}</Card.Text>}
        <Card.Text>{values.email}</Card.Text>
      </Card.Content>
    </Card>
  )
}

export default ContactDetailsSummary
